const labels = {
  FaqCategories: {
    'Ref: Page title': 'คำถามที่พบบ่อย',
    'Ref: Missing Faq': 'คำถามที่พบบ่อยว่างเปล่า',
    'Ref: Go to home page': 'นำทางไปยังโฮมเพจ',
  },
  FaqCategoryDetails: { 'Ref: Page title': 'คำถาม' },
};
export default labels;
